import { Button } from "@/components/ui/button";
import { useCurrentProfile, useToken } from "@/global_state";
import { respondToMatching } from "@/utils";
import { AnimatePresence, motion } from "framer-motion";
import { Heart, ChevronLast, X } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function LikeRejectButtons({
  id,
}: {
  id: string | number | null | undefined;
}) {
  const [authToken, setAuthToken] = useToken();
  const [showMatch, setShowMatch] = useState(false);
  const navigate = useNavigate();
  const [currentProfile, setCurrentProfile] = useCurrentProfile();

  const handleSwipe = (response: "like" | "dislike" | "skip") => {
    respondToMatching(id || "", response, authToken || "", (res) => {
      if (response === "like" && res.data.match) {
        setShowMatch(true);
        setTimeout(() => {
          setShowMatch(false);
          setCurrentProfile(null);
          navigate("/app/home/");
        }, 600);
      } else {
        setCurrentProfile(null);
        navigate("/app/home/");
      }
    });
  };

  return (
    <div className="flex justify-center gap-4">
      <Button
        onClick={() => handleSwipe("dislike")}
        variant="outline"
        size="icon"
        className="w-16 h-16 rounded-full border-gray-600 hover:bg-gray-700"
      >
        <X className="h-8 w-8 text-gray-400" />
        <span className="sr-only">Reject</span>
      </Button>

      <Button
        onClick={() => handleSwipe("skip")}
        variant="outline"
        size="icon"
        className="w-16 h-16 rounded-full border-gray-600 hover:bg-gray-700"
      >
        <ChevronLast className="h-6 w-6 text-gray-400" />
        <span className="sr-only">Skip</span>
      </Button>
      <Button
        onClick={() => handleSwipe("like")}
        size="icon"
        className="w-16 h-16 rounded-full bg-pink-600 hover:bg-pink-700"
      >
        <Heart className="h-8 w-8" />
        <span className="sr-only">Like</span>
      </Button>

      <AnimatePresence>
        {showMatch && (
          <motion.div
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.5 }}
            className="fixed inset-0 flex items-center justify-center pointer-events-none"
          >
            <div className="bg-pink-500 text-white px-6 py-3 rounded-full text-2xl font-bold shadow-lg">
              You like each other!
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
